import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

export const generateFlashcards = createAsyncThunk(
    'flashcardGenerator/generateFlashcards',
    async ({ text, difficulty, qType }, { rejectWithValue }) => {
        try {
            const response = await apiCall('/generate-flashcards', 'POST', { text, difficulty, qType });
            if (response.error) {
                return rejectWithValue(response.message || response.error);
            }
            return response;
        } catch (error) {
            return rejectWithValue('Error generating flashcards');
        }
    }
);

const flashcardSlice = createSlice({
    name: 'flashcardGenerator',
    initialState: {
        flashcards: [],
        loading: false,
        error: null,
    },
    reducers: {
        clearFlashcards: (state) => {
            state.flashcards = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateFlashcards.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(generateFlashcards.fulfilled, (state, action) => {
                state.loading = false;
                state.flashcards = action.payload.flashcards;
            })
            .addCase(generateFlashcards.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'An unexpected error occurred';
            });
    },
});

export const { clearFlashcards } = flashcardSlice.actions;
export default flashcardSlice.reducer;
